import { render, staticRenderFns } from "./ChamadaValorizacao.vue?vue&type=template&id=22550f28&scoped=true&"
import script from "./ChamadaValorizacao.vue?vue&type=script&lang=js&"
export * from "./ChamadaValorizacao.vue?vue&type=script&lang=js&"
import style0 from "./ChamadaValorizacao.vue?vue&type=style&index=0&id=22550f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22550f28",
  null
  
)

export default component.exports